import { render, staticRenderFns } from "./SocialAuthButtons.vue?vue&type=template&id=8be2b1da&scoped=true&"
import script from "./SocialAuthButtons.vue?vue&type=script&lang=js&"
export * from "./SocialAuthButtons.vue?vue&type=script&lang=js&"
import style0 from "./SocialAuthButtons.vue?vue&type=style&index=0&id=8be2b1da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be2b1da",
  null
  
)

export default component.exports